export default "__VITE_ASSET__CDfrH5X2__"